import React from "react";

import {
  FieldContainer,
  RadioGroup,
  RadioItem,
  SubFieldContainer,
  CheckboxGroup,
  CheckboxItem,
  CustomSelect,
  Option,
  Label,
  Note,
  Highlight,
} from "../../components/CustomFields";

import DrinkHeroImage from "../../assets/images/Drink_hero.png";

import InformWarper from "./InformWarper";
import CheckboxWithImageAndQuantity from "../../components/CustomFields/CheckboxWithImageAndQuantity";

import SweetDrinkSImage from "../../assets/images/inform/sweetDrinkSImage.png";
import SweetDrinkMImage from "../../assets/images/inform/sweetDrinkMImage.png";
import SweetDrinkLImage from "../../assets/images/inform/sweetDrinkLImage.png";
import LowSweetDrinkSImage from "../../assets/images/inform/lowSweetDrinkSImage.png";
import LowSweetDrinkMImage from "../../assets/images/inform/lowSweetDrinkMImage.png";
import LowSweetDrinkLImage from "../../assets/images/inform/lowSweetDrinkLImage.png";
import { useState } from "react";

export const quantityOptions = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];

export const normalSweet = [
  {
    name: "normalSweetDrinkSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: SweetDrinkSImage,
    options: quantityOptions,
  },
  {
    name: "normalSweetDrinkMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: SweetDrinkMImage,
    options: quantityOptions,
  },
  {
    name: "normalSweetDrinkLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: SweetDrinkLImage,
    options: quantityOptions,
  },
];

export const sweetLess = [
  {
    name: "lowSweetDrinkSUnit",
    label: "เล็ก",
    desc: "120-199 ml",
    image: LowSweetDrinkSImage,
    options: quantityOptions,
  },
  {
    name: "lowSweetDrinkMUnit",
    label: "กลาง",
    desc: "200-450 ml",
    image: LowSweetDrinkMImage,
    options: quantityOptions,
  },
  {
    name: "lowSweetDrinkLUnit",
    label: "ใหญ่",
    desc: "มากกว่า 450 ml",
    image: LowSweetDrinkLImage,
    options: quantityOptions,
  },
];
// export const sweetLessOptions = normalSweetOptions;

const SweetDrink = ({ form = {}, setFieldsValue }) => {
  const [isDrink, setIsDrink] = useState(undefined);
  return (
    <InformWarper
      name="หยุดยั้งน้ำหวาน"
      desc="ไม่ดื่มน้ำหวาน"
      icon={DrinkHeroImage}
      heroLabel="Drink Hero ชวนศึกษา"
      leftButton="รู้ทัน ฉันปานะ ละน้ำตาล"
      rightButton="การผจญภัยของน้ำตาล"
      onLeftButtonClick={() => {
        window.open("/article/drink?key=read");
      }}
      onRightButtonClick={() => {
        window.open("/article/drink?key=think");
      }}
    >
      <FieldContainer
        name="haveDrunkSweetDrink"
        label="เมื่อวานนี้ทั้งวัน  ท่านได้ดื่มน้ำหวานหรือไม่ (น้ำหวาน หมายถึง น้ำอัดลม เครื่องดื่มที่เติมน้ำตาล น้ำหวานที่เติม
          น้ำตาลเทียม และน้ำผลไม้ที่มีรสหวาน โยเกิร์ตพร้อมดื่ม ชา กาแฟ )"
      >
        <RadioGroup onChange={(e) => setIsDrink(e.target.value)}>
          <RadioItem value={false}>ไม่ดื่ม</RadioItem>
          <RadioItem value={true}>
            ดื่ม
            <br />
            {isDrink && (
              <Label>
                เมื่อวานนี้ทั้งวัน ท่านดื่มน้ำหวานประเภทใด
                อย่างละกี่กล่อง/แก้ว/ขวด/ถุง{" "}
              </Label>
            )}
          </RadioItem>
        </RadioGroup>
      </FieldContainer>
      {form.haveDrunkSweetDrink && (
        <SubFieldContainer>
          <FieldContainer name="normalSweet">
            <CheckboxGroup>
              <CheckboxItem value="normalSweet" style={{ lineHeight: "32px" }}>
                น้ำหวาน
                <br />
                <Label>
                  เช่น น้ำอัดลม เครื่องดื่มที่เติมน้ำตาลและน้ำผลไม้ที่มีรสหวาน
                  โยเกิร์ตพร้อมดื่ม ชา กาแฟ
                </Label>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.normalSweet && form.normalSweet.includes("normalSweet") && (
            <FieldContainer name="normalSweetCount">
              <CheckboxGroup direction="row">
                {normalSweet.map(({ name, label, image, desc, options }) => (
                  <CheckboxWithImageAndQuantity
                    form={form}
                    name={name}
                    label={label}
                    desc={desc}
                    image={image}
                    options={options}
                    isSelected={
                      form.normalSweetCount &&
                      form.normalSweetCount.includes(name)
                    }
                    groupName="normalSweetCount"
                    selectedValues={form.normalSweetCount}
                    setSelectedValues={setFieldsValue}
                  />
                ))}
              </CheckboxGroup>
            </FieldContainer>
          )}
          <FieldContainer name="sweetLess">
            <CheckboxGroup>
              <CheckboxItem value="sweetLess" style={{ lineHeight: "32px" }}>
                น้ำหวาน<Highlight>หวานน้อย</Highlight>
                <br />
                <Label>
                  เช่น เครื่องดื่มที่เติมน้ำตาลเทียม,สั่งน้ำชงแบบหวานน้อย
                </Label>
              </CheckboxItem>
            </CheckboxGroup>
          </FieldContainer>
          {form.sweetLess && form.sweetLess.includes("sweetLess") && (
            <FieldContainer name="sweetLessCount">
              <CheckboxGroup direction="row">
                {sweetLess.map(({ name, label, image, desc, options }) => (
                  <CheckboxWithImageAndQuantity
                    form={form}
                    name={name}
                    label={label}
                    desc={desc}
                    image={image}
                    options={options}
                    isSelected={
                      form.sweetLessCount && form.sweetLessCount.includes(name)
                    }
                    groupName="sweetLessCount"
                    selectedValues={form.sweetLessCount}
                    setSelectedValues={setFieldsValue}
                  />
                ))}
              </CheckboxGroup>
            </FieldContainer>
          )}
        </SubFieldContainer>
      )}
    </InformWarper>
  );
};

export default SweetDrink;
